module.exports = __webpack_public_path__ + "img/choose.f65b444d.svg";